import { render, staticRenderFns } from "./serverEdit.vue?vue&type=template&id=b2c618ae&scoped=true&"
import script from "./serverEdit.vue?vue&type=script&lang=js&"
export * from "./serverEdit.vue?vue&type=script&lang=js&"
import style0 from "./serverEdit.vue?vue&type=style&index=0&id=b2c618ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c618ae",
  null
  
)

export default component.exports